export const config = {
  title: 'Negrete Brothers Plumbing | Expert Plumbing Services in Tonopah, AZ',
  meta: {
    description:
      'Negrete Brothers Plumbing offers top-notch plumbing services in Tonopah, AZ, specializing in new construction, fixture installations, repairs, and remodeling with a commitment to excellence.',
    keywords: [
      'Negrete Brothers Plumbing',
      'Plumbing Services Tonopah AZ',
      'New Construction Plumbing',
      'Fixture Installation',
      'Plumbing Repairs',
      'Bathroom Remodeling',
      'Tonopah Plumbing Experts',
    ],
    author: 'Negrete Brothers Plumbing',
    canonicalUrl: 'https://negretebrosplumbing.com/',
  },
  sections: {
    header: {
      businessName: 'Negrete Brothers Plumbing',
    },
    sectionB: {
      heroTitle: 'Negrete Brothers Plumbing',
      heroSubtitle: 'Your Go-To Plumbing Experts in Tonopah, AZ',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '6028590327',
      phoneLabel: '(602) 859-0327',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1516511531/photo/a-plumber-carefully-fixes-a-leak-in-a-sink-using-a-wrench.jpg?s=612x612&w=0&k=20&c=4WRY5lTezchQ5aLj9gXj0Gixq7Wq7b0tzvrCTt4jrrI=',
      cardData: [
        {
          title: 'New Construction Plumbing',
          description:
            'Expert plumbing services for custom homes and new constructions, ensuring a solid foundation for your property.',
        },
        {
          title: 'Fixture Installation & Repairs',
          description:
            'Professional installation and repair of plumbing fixtures with meticulous attention to detail.',
        },
        {
          title: 'Bathroom Remodeling',
          description:
            'Transform your bathroom with our comprehensive remodeling services, tailored to your vision.',
        },
      ],
      description:
        'At Negrete Brothers Plumbing, we provide a wide range of plumbing services, including new construction plumbing, fixture installations, small repairs, and bathroom remodeling. With over a decade of experience and a family tradition spanning four generations, we are committed to excellence and customer satisfaction.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our comprehensive plumbing services designed to meet all your residential needs.',
      cards: [
        {
          title: 'New Construction Plumbing',
          description:
            'Specializing in plumbing systems for new custom homes, ensuring efficiency and reliability.',
          imageSrc: 'https://negretebrosplumbing.com/wp-content/uploads/2023/10/All-About.jpg',
          imageAlt: 'New Construction Plumbing',
        },
        {
          title: 'Fixture Services',
          description:
            'Professional installation and setting of plumbing fixtures, enhancing the functionality and aesthetics of your home.',
          imageSrc: 'https://negretebrosplumbing.com/wp-content/uploads/2023/10/Fixtures.jpg',
          imageAlt: 'Fixture Installation',
        },
        {
          title: 'Small Repairs',
          description:
            'Prompt and efficient solutions for minor plumbing issues to prevent major problems.',
          imageSrc: 'https://negretebrosplumbing.com/wp-content/uploads/2023/10/small.jpg',
          imageAlt: 'Plumbing Repairs',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Whole House Plumbing Upgrades',
        'Emergency Plumbing Services',
        'Leak Detection and Repair',
        'Water Heater Installation',
        'Drain Cleaning',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://negretebrosplumbing.com/wp-content/uploads/2023/02/Negrete-removebg-preview.png',
        alt: 'Negrete Brothers Plumbing Team',
      },
      aboutText: [
        'Negrete Brothers Plumbing is a family-owned business with a legacy spanning four generations. Founded by Rogelio Negrete, who began his plumbing career at 15, we bring over a decade of experience to every project.',
        'Our commitment to excellence and meticulous attention to detail have made us a trusted name in Tonopah, AZ, for all plumbing needs.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Negrete Brothers Plumbing Logo',
      businessName: 'Negrete Brothers Plumbing',
      contact: {
        phone: '6028590327',
        phoneLabel: '(602) 859-0327',
        email: 'negretebrothersplumbing@gmail.com',
        website: 'https://negretebrosplumbing.com/',
        address: '3518 359th N Ave, Tonopah, AZ 85354',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '3518 359th N Ave, Tonopah, AZ 85354',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3367.5105881886655!2d-112.9393416844882!3d33.49364387918219!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x872b1a4e5e5e5e5e%3A0x5e5e5e5e5e5e5e5e!2s3518%20359th%20N%20Ave%2C%20Tonopah%2C%20AZ%2085354!5e0!3m2!1sen!2sus!4v1712608000000!5m2!1sen!2sus',
    },
  },
};

export default config;
